(function () {
  const intervalTime = 500;
  const maxTime = 20000;

  // Reusable function to add aria attributes to element
  function makeButton(element, label) {
    const patchedAttr = "data-a11y-patched";

    if (!element) return false;
    if (element.hasAttribute(patchedAttr)) return true;

    element.setAttribute("role", "button");
    element.setAttribute("aria-label", label);

    if (!element.hasAttribute("tabindex")) {
      element.setAttribute("tabindex", "0");
    }

    element.addEventListener("keydown", function (event) {
      if (event.key === "Enter" || event.key === " ") {
        event.preventDefault();
        element.click();
      }
    });

    element.setAttribute(patchedAttr, "true");

    return true;
  }

  // Fix BV filter button
  function patchBazaarvoiceFiltersButton() {
    const element = document.querySelector(
      '[data-bv-show="reviews"] .bv-rnr__sc-1kd7i6j-0.gRnrQW',
    );

    return makeButton(element, "Filters");
  }

  // Fix BV sort button
  function patchBazaarvoiceSortButton() {
    const element = document.querySelector(
      '[data-bv-show="reviews"] .bv-rnr__sc-1kd7i6j-0.jfLCGO',
    );

    return makeButton(element, "Sort reviews");
  }

  // BV renders this rating summary as an inactive button inside quick-add modals
  function patchQuickProductModalRatingButton() {
    document
      .querySelectorAll(
        '[data-quick-product-modal] [data-bv-show="rating_summary"] .bv_main_rating_button',
      )
      .forEach(function (button) {
        if (button.getAttribute("tabindex") !== "-1") {
          button.setAttribute("tabindex", "-1");
        }

        button.removeAttribute("aria-haspopup");
        button.removeAttribute("aria-expanded");
        button.removeAttribute("aria-controls");
      });
  }

  function watchQuickProductModalRatingButton() {
    const modal = document.querySelector("[data-quick-product-modal]");

    if (!modal) {
      return;
    }

    patchQuickProductModalRatingButton();

    if (!window.MutationObserver) {
      return;
    }

    new MutationObserver(patchQuickProductModalRatingButton).observe(modal, {
      attributes: true,
      childList: true,
      subtree: true,
    });
  }

  function runWhenReady(callback) {
    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", callback, { once: true });
      return;
    }

    callback();
  }

  function startTimedPatches() {
    let patches = [patchBazaarvoiceFiltersButton, patchBazaarvoiceSortButton];
    const startTime = Date.now();

    function runPatches() {
      patches = patches.filter(function (patch) {
        return !patch();
      });
    }

    runPatches();

    if (patches.length === 0) {
      return;
    }

    const interval = setInterval(function () {
      runPatches();

      if (patches.length === 0 || Date.now() - startTime >= maxTime) {
        clearInterval(interval);
      }
    }, intervalTime);
  }

  startTimedPatches();
  runWhenReady(watchQuickProductModalRatingButton);
})();
